var map = {
	"./about-image.png": 548,
	"./computer-setup.png": 401,
	"./gaming.png": 697,
	"./icons8-multiply-100.png": 498,
	"./lady.png": 646,
	"./laptop-1.png": 23,
	"./office.png": 467,
	"./tab.png": 845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;